import React, { Component } from 'react';
import { Paper, PaperTitle } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';

import TransmissionReportSummary from 'containers/TransmissionReportSummary';
import UploadTransmissionReport from 'containers/UploadTransmissionReport';
import PdfViewer from 'components/PdfViewer';

class AddTransmissionReport extends Component {
  static propTypes = {
    newReportReset: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    step: PropTypes.number.isRequired,
    t: PropTypes.func.isRequired,
    deviceVendor: PropTypes.string.isRequired,
    transmissionType: PropTypes.string.isRequired,
    unscheduledVisitReason: PropTypes.string,
    match: ReactRouterPropTypes.match.isRequired,
    pdfFileObject: PropTypes.shape({}),
  };

  static defaultProps = {
    pdfFileObject: null,
    unscheduledVisitReason: null,
  };

  componentWillUnmount() {
    const { newReportReset } = this.props;
    newReportReset();
  }

  renderContent() {
    const {
      step,
      deviceVendor,
      transmissionType,
      pdfFileObject,
      onSubmit,
      match,
      unscheduledVisitReason,
    } = this.props;

    switch (step) {
      case 1:
        return (
          <UploadTransmissionReport
            deviceVendor={deviceVendor}
            transmissionType={transmissionType}
            unscheduledVisitReason={unscheduledVisitReason}
          />
        );
      case 2:
        return (
          <>
            {pdfFileObject && <PdfViewer pdfFileObject={pdfFileObject} />}
            <TransmissionReportSummary
              onSubmit={onSubmit}
              patientId={match.params.id}
              transmissionType={transmissionType}
              unscheduledVisitReason={unscheduledVisitReason}
            />
          </>
        );
      default:
        return null;
    }
  }

  render() {
    const { step, t } = this.props;

    return (
      <Paper>
        <PaperTitle withBorder>
          {t('reports.newTransmissionReport')} - {t('reports.step', { step })}
        </PaperTitle>
        {this.renderContent()}
      </Paper>
    );
  }
}

export default withTranslation()(AddTransmissionReport);
